import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

export const driverDashboardGuard: CanActivateFn = (route, state) => {
     const authService = inject(AuthenticationService);

     let isAuthenticated = (!authService.setUser() && !authService.getUser()) ? false : true;
     if (!isAuthenticated) {
          // Not logged in
          return inject(Router).navigate(['/']);
     }

     const roles = authService.getRoles();
     const isDriver: boolean = roles !== null && roles.length > 0 && roles.includes('driver');
     if (!isDriver) {
          // Not authorized
          return inject(Router).navigate(['/accessDenied']);
     }
     authService.setAccountType('oa');

     const hasAgreedToTerms = authService.getHasAgreedToTerms();
     if (!hasAgreedToTerms) {
          // Has not agreed to T&C
          return inject(Router).navigate(['/termsandconditions']);
     }
               
     // Authorized and has agreed to T&C.
     return true;   
};
